import React, {
    useEffect,
    useMemo,
    useRef,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import Swal from 'sweetalert2';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';
import HeaderDos from '../../Metodos/Compartidos/HeaderDos.js';
import CobroDetalleModal from './CobroDetalleModal.js';
import HistorialCobrosModal from './HistorialCobrosModal.js';
import RegistrarCobroModal from './RegistrarCobroModal.js';
import CentrosLiquidaciones from './CentrosLiquidaciones.js';

import useConfigAuth from '../../../Hooks/useConfigAuth.js';

import {
    cargarEstadisticasPacienteAction,
    cargarEstadisticasProfesionalAction,
    cargarHistorialPagosCuentaAction,
    registrarPagoAction,
    cambiarCobrableCargoAction,
    anularPagoAction,
    cargarResumenEconomicoCompletoAction,
    aplicarSaldoAFavorAction
} from '../../../actions/estadisticasPacienteActions.js';

import {
    Cuerpo
} from '../../Css/StyledHeader.js';

import {
    EstadisticasMain,
    EstadisticasCabecera,
    EstadisticasTituloContenedor,
    EstadisticasTitulo,
    EstadisticasSubtitulo,
    AccionesCabecera,
    BotonSecundario,
    BotonPrincipal,

    ContenedorFiltros,
    GrupoPeriodos,
    BotonPeriodo,
    PeriodoTexto,

    GridKpis,
    TarjetaKpi,
    KpiTitulo,
    KpiValor,
    KpiDetalle,

    GridEconomia,
    TarjetaEconomia,
    EconomiaTitulo,
    PuntoColor,
    EconomiaValor,
    EconomiaDetalle,
    BotonAccionEconomia,
    BotonOrdenTabla,
    BotonAyudaConceptos,
    BuscadorPacientes,
    BarraResumenPacientes,

    AvisoDeuda,
    AvisoDeudaIcono,
    AvisoDeudaContenido,
    AvisoDeudaTitulo,
    AvisoDeudaTexto,

    GridPaneles,
    Panel,
    PanelCabecera,
    PanelTitulo,
    PanelSubtitulo,

    PresentismoContenido,
    GraficoPresentismo,
    GraficoPresentismoTexto,
    GraficoPresentismoValor,
    GraficoPresentismoLabel,

    ListaAsistencia,
    ItemAsistencia,
    ItemAsistenciaValor,

    FilaEconomia,
    FilaEconomiaNombre,
    FilaEconomiaValor,

    BarraProgreso,
    BarraProgresoInterna,
    BarraProgresoDetalle,

    SeccionTitulo,
    SeccionTituloPrincipal,
    SeccionTituloSecundario,

    TablaContenedor,
    TablaTurnos,
    EstadoBadge,
    Importe,

    SinInformacion,
    CargandoEstadisticas,

    FechasPersonalizadas,
    FechaPersonalizadaGrupo,
    FechaPersonalizadaLabel,
    FechaPersonalizadaInput,

    SelectorModuloContenedor,
    SelectorModuloBoton
} from '../../Css/StyledEstadisticasCobros.js';


/*
====================================
FORMATEAR FECHA LOCAL
====================================

Convierte Date a YYYY-MM-DD.

No usamos toISOString() porque
puede modificar el día según la
zona horaria.
====================================
*/

const formatDateLocal = (date) => {

    const year =
        date.getFullYear();

    const month =
        String(
            date.getMonth() + 1
        ).padStart(2, '0');

    const day =
        String(
            date.getDate()
        ).padStart(2, '0');

    return `${year}-${month}-${day}`;
};


/*
====================================
FORMATEAR FECHA PARA MOSTRAR
====================================
*/

const formatDateDisplay = (dateString) => {

    if (!dateString) {
        return '';
    }

    const [
        year,
        month,
        day
    ] = dateString.split('-');

    return `${day}/${month}/${year}`;
};


/*
====================================
FORMATEAR DINERO
====================================
*/

const formatMoney = (value) => {

    const numero =
        Number(value || 0);

    return new Intl.NumberFormat(
        'es-AR',
        {
            style: 'currency',
            currency: 'ARS',
            maximumFractionDigits: 0
        }
    ).format(numero);
};


/*
====================================
PERÍODO MES ACTUAL
====================================
*/

const getCurrentMonthPeriod = () => {

    const now =
        new Date();

    return {

        fecha_desde:
            formatDateLocal(
                new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    1
                )
            ),

        fecha_hasta:
            formatDateLocal(
                new Date(
                    now.getFullYear(),
                    now.getMonth() + 1,
                    0
                )
            )

    };
};


/*
====================================
PERÍODO MES ANTERIOR
====================================
*/

const getPreviousMonthPeriod = () => {

    const now =
        new Date();

    const previousMonth =
        new Date(
            now.getFullYear(),
            now.getMonth() - 1,
            1
        );

    return {

        fecha_desde:
            formatDateLocal(
                new Date(
                    previousMonth.getFullYear(),
                    previousMonth.getMonth(),
                    1
                )
            ),

        fecha_hasta:
            formatDateLocal(
                new Date(
                    previousMonth.getFullYear(),
                    previousMonth.getMonth() + 1,
                    0
                )
            )

    };
};


/*
====================================
PERÍODO AÑO ACTUAL
====================================
*/

const getCurrentYearPeriod = () => {

    const now =
        new Date();

    return {

        fecha_desde:
            formatDateLocal(
                new Date(
                    now.getFullYear(),
                    0,
                    1
                )
            ),

        fecha_hasta:
            formatDateLocal(
                new Date(
                    now.getFullYear(),
                    11,
                    31
                )
            )

    };
};


/*
====================================
LABEL ESTADO TURNO
====================================
*/

const getEstadoTurnoLabel = (estado) => {

    switch (estado) {

        case 'REALIZADO':
            return 'Realizado';

        case 'CANCELADO':
            return 'Cancelado';

        case 'NO_ASISTIO':
            return 'No asistió';

        case 'PENDIENTE':
            return 'Pendiente';

        default:
            return estado || '—';
    }

};


/*
====================================
LABEL ESTADO PAGO
====================================
*/

const getEstadoPagoLabel = (estado) => {

    switch (estado) {

        case 'COBRADO':
            return 'Cobrado';

        case 'PARCIAL':
            return 'Parcial';

        case 'PENDIENTE':
            return 'Pendiente';

        case 'NO_COBRABLE':
            return 'No cobrar';

        case 'SIN_CARGO':
            return 'Sin cargo';

        default:
            return estado || 'Sin cargo';
    }

};

/*
====================================
LABEL TIPO DE TURNO
====================================
*/

const getTipoTurnoLabel = (tipo) => {

    switch (tipo) {

        case 'SESION_PACIENTE':
            return 'Sesión con paciente';

        case 'REUNION_PADRES':
            return 'Reunión con padres';

        case 'REUNION_COLEGIO':
            return 'Reunión con colegio';

        case 'REUNION_PROFESIONALES':
            return 'Reunión con profesionales';

        default:
            return tipo || '—';

    }

};

/*
====================================
ESTADÍSTICAS Y COBROS
====================================
*/

const EstadisticasCobros = () => {

    const dispatch =
        useDispatch();

    const [config] =
        useConfigAuth();

    /*
    ====================================
    VISTA PRINCIPAL
    ====================================

    PACIENTES:
    estadísticas y cobros actuales.

    CENTROS:
    liquidaciones y pagos a centros.
    ====================================
    */

    const [
        vistaModulo,
        setVistaModulo
    ] = useState(
        'PACIENTES'
    );


    /*
    ====================================
    CENTROS INICIALIZADOS
    ====================================

    CentrosLiquidaciones se monta solamente
    la primera vez que el profesional entra
    a esa solapa.

    Después permanece montado aunque se
    vuelva a Pacientes.

    Esto evita volver a consultar al backend
    cada vez que se cambia de solapa.
    ====================================
    */

    const [
        centrosInicializados,
        setCentrosInicializados
    ] = useState(
        false
    );

    const [
        refrescoCentrosVersion,
        setRefrescoCentrosVersion
    ] = useState(
        0
    );


    /*
    ====================================
    CAMBIAR MÓDULO
    ====================================
    */

    const handleCambiarVistaModulo = (
        modulo
    ) => {

        if (
            modulo ===
            'CENTROS'
        ) {

            setCentrosInicializados(
                true
            );


            /*
            ====================================
            VOLVIENDO A CENTROS
            ====================================

            Incrementamos solamente cuando
            veníamos desde otra solapa.

            Esto permite que Centros refresque
            únicamente la información que pudo
            cambiar mientras trabajábamos en
            Pacientes.
            ====================================
            */

            if (
                vistaModulo !==
                'CENTROS'
            ) {

                setRefrescoCentrosVersion(
                    (version) =>
                        version + 1
                );

            }

        }


        setVistaModulo(
            modulo
        );

    };
    
    /*
    ====================================
    PACIENTE GLOBAL
    ====================================
    */

    const idPacienteRedux =
        useSelector(
            (state) =>
                state.usuario?.id_paciente ||
                ''
        );


    const pacientes =
        useSelector(
            (state) =>
                state.informacion?.lista_pacientes ||
                []
        );


    /*
    ====================================
    PACIENTE LOCAL
    ====================================
    */

    const [
        idPacienteSeleccionado,
        setIdPacienteSeleccionado
    ] = useState(
        idPacienteRedux || 'TODOS'
    );


    /*
    ====================================
    HISTORIAL DE COBROS
    ====================================
    */

    const [
        historialCobros,
        setHistorialCobros
    ] = useState(null);


    const [
        cargandoHistorial,
        setCargandoHistorial
    ] = useState(false);


    const [
        historialAbierto,
        setHistorialAbierto
    ] = useState(false);


    /*
    ====================================
    REGISTRAR COBRO
    ====================================
    */

    const [
        registrarCobroAbierto,
        setRegistrarCobroAbierto
    ] = useState(false);


    const [
        datosInicialesCobro,
        setDatosInicialesCobro
    ] = useState(null);


    const [
        cargosParaCobro,
        setCargosParaCobro
    ] = useState([]);


    const [
        cargandoCargosParaCobro,
        setCargandoCargosParaCobro
    ] = useState(false);


    const [
        registrandoCobro,
        setRegistrandoCobro
    ] = useState(false);


    /*
    ====================================
    ANULAR PAGO
    ====================================
    */

    const [
        anulandoPagoId,
        setAnulandoPagoId
    ] = useState(null);


    /*
    ====================================
    SALDO A FAVOR
    ====================================
    */

    const [
        aplicandoSaldoFavor,
        setAplicandoSaldoFavor
    ] = useState(false);


    /*
    ====================================
    PERÍODO
    ====================================
    */

    const [
        tipoPeriodo,
        setTipoPeriodo
    ] = useState(
        'MES_ACTUAL'
    );


    const [
        fechaDesdePersonalizada,
        setFechaDesdePersonalizada
    ] = useState('');


    const [
        fechaHastaPersonalizada,
        setFechaHastaPersonalizada
    ] = useState('');


    /*
    ====================================
    TURNO SELECCIONADO
    ====================================
    */

    const [
        turnoSeleccionado,
        setTurnoSeleccionado
    ] = useState(null);


    /*
    ====================================
    CAMBIANDO COBRABLE
    ====================================
    */

    const [
        cambiandoCobrable,
        setCambiandoCobrable
    ] = useState(false);


    /*
    ====================================
    ORDEN RESUMEN DE PACIENTES
    ====================================

    Por defecto aparecen primero
    quienes tienen mayor deuda.
    ====================================
    */

    const [
        ordenPacientes,
        setOrdenPacientes
    ] = useState({

        campo:
            'total_adeudado',

        direccion:
            'desc'

    });


    /*
    ====================================
    FILTRO RESUMEN DE PACIENTES
    ====================================
    */

    const [
        filtroPacientes,
        setFiltroPacientes
    ] = useState(
        'TODOS'
    );


    /*
    ====================================
    VISTA ACTIVOS / ARCHIVADOS
    ====================================
    */

    const [
        vistaPacientes,
        setVistaPacientes
    ] = useState(
        'activos'
    );


    /*
    ====================================
    BUSCAR PACIENTE EN RESUMEN
    ====================================
    */

    const [
        busquedaPaciente,
        setBusquedaPaciente
    ] = useState('');


    /*
    ====================================
    ABRIR DETALLE
    ====================================
    */

    const handleAbrirDetalle = (turno) => {

        setTurnoSeleccionado(
            turno
        );

    };


    /*
    ====================================
    CERRAR DETALLE
    ====================================
    */

    const handleCerrarDetalle = () => {

        setTurnoSeleccionado(
            null
        );

    };


    /*
    ====================================
    DATOS REDUX
    ====================================
    */

    const estadisticasPaciente =
        useSelector(
            (state) =>
                state.estadisticasPaciente
        );


    const cargando =
        Boolean(
            estadisticasPaciente?.cargando
        );


    const asistenciaBackend =
        estadisticasPaciente?.asistencia ||
        {
            total_computable: 0,
            presentes: 0,
            ausentes: 0,
            no_asistio: 0,
            cancelados: 0,
            porcentaje_presentismo: 0,
            porcentaje_ausentismo: 0
    };

    /*
    ====================================
    ASISTENCIA PADRES
    ====================================

    Se mantiene completamente separada
    de la asistencia del paciente.

    Solo existe en la vista individual.
    ====================================
    */

    const asistenciaPadresBackend =
        estadisticasPaciente?.asistencia_padres ||
        {
            total_computable: 0,
            presentes: 0,
            ausentes: 0,
            no_asistio: 0,
            cancelados: 0,
            porcentaje_presentismo: 0,
            porcentaje_ausentismo: 0
        };

    const economia =
        estadisticasPaciente?.economia ||
        {
            cuenta: null,
            resumen: null,
            cargos: []
        };


    const resumenEconomicoBackend =
        economia?.resumen ||
        {
            total_generado: 0,
            total_cobrado: 0,
            total_ingresado_periodo: 0,
            saldo_pendiente: 0,
            deuda_anterior: 0,
            saldo_a_favor: 0
        };


    const turnos =
        Array.isArray(
            estadisticasPaciente?.turnos
        )
            ? estadisticasPaciente.turnos
            : [];


    /*
    ====================================
    VISTA TODOS LOS PACIENTES
    ====================================
    */

    const esVistaGlobal =
        idPacienteSeleccionado ===
        'TODOS';


    /*
    ====================================
    RESUMEN GLOBAL POR PACIENTE
    ====================================
    */

    const resumenPacientes =
        Array.isArray(
            estadisticasPaciente?.pacientes
        )
            ? estadisticasPaciente.pacientes
            : [];


    /*
    ====================================
    COMBINAR LISTA + ESTADÍSTICAS
    ====================================

    Construimos una unión entre:

    1. pacientes disponibles actualmente
       en lista_pacientes;

    2. pacientes que aparecen solamente
       en las estadísticas económicas.

    Esto evita que una deuda histórica
    forme parte de los totales generales
    pero desaparezca de la tabla.

    No se realiza ninguna consulta extra.
    ====================================
    */

    const pacientesResumenCompleto =
        useMemo(() => {

            if (!esVistaGlobal) {
                return [];
            }


            /*
            ====================================
            ESTADÍSTICAS POR ID
            ====================================
            */

            const resumenPorId =
                new Map(
                    resumenPacientes.map(
                        (item) => [
                            String(
                                item.id_paciente
                            ),
                            item
                        ]
                    )
                );


            /*
            ====================================
            IDS YA INCORPORADOS
            ====================================
            */

            const idsIncorporados =
                new Set();


            /*
            ====================================
            PACIENTES DE LA LISTA ACTUAL
            ====================================
            */

            const resultado =
                pacientes.map(
                    (paciente) => {

                        const idPaciente =
                            String(
                                paciente.id_paciente
                            );


                        idsIncorporados.add(
                            idPaciente
                        );


                        const resumen =
                            resumenPorId.get(
                                idPaciente
                            );


                        return {

                            id_paciente:
                                paciente.id_paciente,

                            nombre:
                                paciente.nombre ||
                                '',

                            apellido:
                                paciente.apellido ||
                                '',

                            es_historico:
                                false,

                            archivado:
                                Boolean(
                                    paciente.archivado
                                ),

                            fecha_archivado:
                                paciente.fecha_archivado ||
                                null,

                            sesiones_computables:
                                resumen?.sesiones_computables ||
                                0,

                            presentes:
                                resumen?.presentes ||
                                0,

                            ausentes:
                                resumen?.ausentes ||
                                0,

                            no_asistio:
                                resumen?.no_asistio ||
                                0,

                            cancelados:
                                resumen?.cancelados ||
                                0,

                            porcentaje_presentismo:
                                Number(
                                    resumen?.porcentaje_presentismo ||
                                    0
                                ),

                            porcentaje_ausentismo:
                                Number(
                                    resumen?.porcentaje_ausentismo ||
                                    0
                                ),

                            total_generado:
                                Number(
                                    resumen?.total_generado ||
                                    0
                                ),

                            total_cobrado:
                                Number(
                                    resumen?.total_cobrado ||
                                    0
                                ),

                            total_ingresado_periodo:
                                Number(
                                    resumen?.total_ingresado_periodo ||
                                    0
                                ),

                            saldo_pendiente:
                                Number(
                                    resumen?.saldo_pendiente ||
                                    0
                                ),

                            deuda_anterior:
                                Number(
                                    resumen?.deuda_anterior ||
                                    0
                                ),

                            total_adeudado:
                                Number(
                                    resumen?.total_adeudado ||
                                    0
                                ),

                            saldo_a_favor:
                                Number(
                                    resumen?.saldo_a_favor ||
                                    0
                                )

                        };

                    }
                );


            /*
            ====================================
            PACIENTES SOLO EN ESTADÍSTICAS
            ====================================

            Puede ocurrir con un paciente
            histórico que ya no forme parte
            de lista_pacientes pero conserve:

            - deuda;
            - pagos;
            - saldo a favor;
            - movimientos anteriores.

            Lo mostramos para que los totales
            siempre puedan reconciliarse con
            la tabla.
            ====================================
            */

            resumenPacientes.forEach(
                (resumen) => {

                    const idPaciente =
                        String(
                            resumen.id_paciente
                        );


                    if (
                        idsIncorporados.has(
                            idPaciente
                        )
                    ) {
                        return;
                    }


                    resultado.push({

                        id_paciente:
                            resumen.id_paciente,

                        /*
                        ====================================
                        NOMBRE DEL PACIENTE HISTÓRICO
                        ====================================
                        */

                        nombre:
                            resumen.nombre ||
                            'Paciente histórico',

                        apellido:
                            resumen.apellido ||
                            '',

                        es_historico:
                            true,

                        archivado:
                            Boolean(
                                resumen.archivado
                            ),

                        fecha_archivado:
                            resumen.fecha_archivado ||
                            null,

                        sesiones_computables:
                            resumen.sesiones_computables ||
                            0,

                        presentes:
                            resumen.presentes ||
                            0,

                        ausentes:
                            resumen.ausentes ||
                            0,

                        no_asistio:
                            resumen.no_asistio ||
                            0,

                        cancelados:
                            resumen.cancelados ||
                            0,

                        porcentaje_presentismo:
                            Number(
                                resumen.porcentaje_presentismo ||
                                0
                            ),

                        porcentaje_ausentismo:
                            Number(
                                resumen.porcentaje_ausentismo ||
                                0
                            ),

                        total_generado:
                            Number(
                                resumen.total_generado ||
                                0
                            ),

                        total_cobrado:
                            Number(
                                resumen.total_cobrado ||
                                0
                            ),

                        total_ingresado_periodo:
                            Number(
                                resumen.total_ingresado_periodo ||
                                0
                            ),

                        saldo_pendiente:
                            Number(
                                resumen.saldo_pendiente ||
                                0
                            ),

                        deuda_anterior:
                            Number(
                                resumen.deuda_anterior ||
                                0
                            ),

                        total_adeudado:
                            Number(
                                resumen.total_adeudado ||
                                0
                            ),

                        saldo_a_favor:
                            Number(
                                resumen.saldo_a_favor ||
                                0
                            )

                    });

                }
            );


            return resultado;

        }, [
            esVistaGlobal,
            pacientes,
            resumenPacientes
        ]);


    /*
    ====================================
    PACIENTES SEGÚN VISTA
    ====================================

    Activos:
    archivado !== true

    Archivados:
    archivado === true

    Todo se filtra localmente.
    No realiza consultas al backend.
    ====================================
    */

    const pacientesResumenPorVista =
        useMemo(() => {

            if (
                vistaPacientes ===
                'archivados'
            ) {

                return pacientesResumenCompleto.filter(
                    (paciente) =>
                        paciente.archivado === true
                );

            }


            return pacientesResumenCompleto.filter(
                (paciente) =>
                    paciente.archivado !== true
            );

        }, [
            pacientesResumenCompleto,
            vistaPacientes
        ]);

        /*
        ====================================
        CANTIDAD ACTIVOS / ARCHIVADOS
        ====================================
        */

        const cantidadesVistaPacientes =
            useMemo(() => {

                const activos =
                    pacientesResumenCompleto.filter(
                        (paciente) =>
                            paciente.archivado !== true
                    ).length;


                const archivados =
                    pacientesResumenCompleto.filter(
                        (paciente) =>
                            paciente.archivado === true
                    ).length;


                return {
                    activos,
                    archivados
                };

            }, [
                pacientesResumenCompleto
            ]);


        /*
        ====================================
        CAMBIAR VISTA
        ====================================
        */

        const handleCambiarVistaPacientes =
            (nuevaVista) => {

                setVistaPacientes(
                    nuevaVista
                );

                /*
                Al cambiar Activos / Archivados
                volvemos a mostrar todos los
                pacientes de esa vista.
                */

                setFiltroPacientes(
                    'TODOS'
                );

                setBusquedaPaciente(
                    ''
                );

            };

    /*
    ====================================
    TOTALES GLOBALES SEGÚN VISTA
    ====================================

    Cuando estamos en "Todos los pacientes"
    no usamos directamente los totales
    generales enviados por el backend.

    Los recalculamos con los pacientes
    visibles según la vista:

    - activos;
    - archivados.

    Esto permite cambiar de una vista
    a otra sin realizar otra consulta.
    ====================================
    */

    const resumenGlobalPorVista =
        useMemo(() => {

            const acumulado =
                pacientesResumenPorVista.reduce(
                    (total, paciente) => {

                        total.total_computable +=
                            Number(
                                paciente.sesiones_computables ||
                                0
                            );


                        total.presentes +=
                            Number(
                                paciente.presentes ||
                                0
                            );


                        total.ausentes +=
                            Number(
                                paciente.ausentes ||
                                0
                            );


                        total.no_asistio +=
                            Number(
                                paciente.no_asistio ||
                                0
                            );


                        total.cancelados +=
                            Number(
                                paciente.cancelados ||
                                0
                            );


                        total.total_generado +=
                            Number(
                                paciente.total_generado ||
                                0
                            );


                        total.total_cobrado +=
                            Number(
                                paciente.total_cobrado ||
                                0
                            );


                        total.total_ingresado_periodo +=
                            Number(
                                paciente.total_ingresado_periodo ||
                                0
                            );


                        total.saldo_pendiente +=
                            Number(
                                paciente.saldo_pendiente ||
                                0
                            );


                        total.deuda_anterior +=
                            Number(
                                paciente.deuda_anterior ||
                                0
                            );


                        total.saldo_a_favor +=
                            Number(
                                paciente.saldo_a_favor ||
                                0
                            );


                        return total;

                    },
                    {

                        total_computable: 0,

                        presentes: 0,

                        ausentes: 0,

                        no_asistio: 0,

                        cancelados: 0,

                        total_generado: 0,

                        total_cobrado: 0,

                        total_ingresado_periodo: 0,

                        saldo_pendiente: 0,

                        deuda_anterior: 0,

                        saldo_a_favor: 0

                    }
                );


            const porcentajePresentismo =
                acumulado.total_computable > 0

                    ? Number(
                        (
                            (
                                acumulado.presentes /
                                acumulado.total_computable
                            ) *
                            100
                        ).toFixed(2)
                    )

                    : 0;


            const porcentajeAusentismo =
                acumulado.total_computable > 0

                    ? Number(
                        (
                            (
                                acumulado.ausentes /
                                acumulado.total_computable
                            ) *
                            100
                        ).toFixed(2)
                    )

                    : 0;


            return {

                asistencia: {

                    total_computable:
                        acumulado.total_computable,

                    presentes:
                        acumulado.presentes,

                    ausentes:
                        acumulado.ausentes,

                    no_asistio:
                        acumulado.no_asistio,

                    cancelados:
                        acumulado.cancelados,

                    porcentaje_presentismo:
                        porcentajePresentismo,

                    porcentaje_ausentismo:
                        porcentajeAusentismo

                },


                economia: {

                    total_generado:
                        acumulado.total_generado,

                    total_cobrado:
                        acumulado.total_cobrado,

                    total_ingresado_periodo:
                        acumulado.total_ingresado_periodo,

                    saldo_pendiente:
                        acumulado.saldo_pendiente,

                    deuda_anterior:
                        acumulado.deuda_anterior,

                    saldo_a_favor:
                        acumulado.saldo_a_favor

                }

            };

        }, [
            pacientesResumenPorVista
        ]);


    /*
    ====================================
    DATOS QUE MOSTRAMOS EN PANTALLA
    ====================================

    Paciente individual:
    usamos los datos originales del backend.

    Todos los pacientes:
    usamos los totales recalculados según
    Activos / Archivados.
    ====================================
    */

    const asistencia =
        esVistaGlobal
            ? resumenGlobalPorVista.asistencia
            : asistenciaBackend;


    const resumenEconomico =
        esVistaGlobal
            ? resumenGlobalPorVista.economia
            : resumenEconomicoBackend;


    /*
    ====================================
    CAMBIAR ORDEN DE PACIENTES
    ====================================
    */

    const handleOrdenarPacientes = (
        campo
    ) => {

        setOrdenPacientes(
            (ordenAnterior) => {

                if (
                    ordenAnterior.campo ===
                    campo
                ) {

                    return {

                        campo,

                        direccion:
                            ordenAnterior.direccion ===
                            'asc'
                                ? 'desc'
                                : 'asc'

                    };

                }


                return {

                    campo,

                    direccion:
                        campo === 'nombre'
                            ? 'asc'
                            : 'desc'

                };

            }
        );

    };


    /*
    ====================================
    PACIENTES ORDENADOS
    ====================================
    */

    const pacientesResumenOrdenado =
        useMemo(() => {

            const copia =
                [
                    ...pacientesResumenPorVista
                ];


            copia.sort(
                (pacienteA, pacienteB) => {

                    let comparacion =
                        0;


                    if (
                        ordenPacientes.campo ===
                        'nombre'
                    ) {

                        const nombreA =
                            `${pacienteA.apellido || ''} ${pacienteA.nombre || ''}`
                                .trim()
                                .toLocaleLowerCase(
                                    'es'
                                );


                        const nombreB =
                            `${pacienteB.apellido || ''} ${pacienteB.nombre || ''}`
                                .trim()
                                .toLocaleLowerCase(
                                    'es'
                                );


                        comparacion =
                            nombreA.localeCompare(
                                nombreB,
                                'es'
                            );

                    } else {

                        const valorA =
                            Number(
                                pacienteA[
                                    ordenPacientes.campo
                                ] ||
                                0
                            );


                        const valorB =
                            Number(
                                pacienteB[
                                    ordenPacientes.campo
                                ] ||
                                0
                            );


                        comparacion =
                            valorA -
                            valorB;

                    }


                    if (
                        ordenPacientes.direccion ===
                        'desc'
                    ) {

                        comparacion =
                            comparacion * -1;

                    }


                    if (
                        comparacion === 0
                    ) {

                        const nombreA =
                            `${pacienteA.apellido || ''} ${pacienteA.nombre || ''}`;


                        const nombreB =
                            `${pacienteB.apellido || ''} ${pacienteB.nombre || ''}`;


                        return nombreA.localeCompare(
                            nombreB,
                            'es'
                        );

                    }


                    return comparacion;

                }
            );


            return copia;

        }, [
            pacientesResumenPorVista,
            ordenPacientes
        ]);


    /*
    ====================================
    TIENE MOVIMIENTO ECONÓMICO
    ====================================
    */

    const tieneMovimientoEconomico = (
        paciente
    ) => {

        return (
            Number(
                paciente.total_generado ||
                0
            ) > 0 ||

            Number(
                paciente.total_cobrado ||
                0
            ) > 0 ||

            Number(
                paciente.total_ingresado_periodo ||
                0
            ) > 0 ||

            Number(
                paciente.total_adeudado ||
                0
            ) > 0 ||

            Number(
                paciente.saldo_a_favor ||
                0
            ) > 0
        );

    };


    /*
    ====================================
    CANTIDADES DE LOS FILTROS
    ====================================
    */

    const cantidadesFiltroPacientes =
        useMemo(() => {

            const todos =
                pacientesResumenOrdenado.length;


            const conDeuda =
                pacientesResumenOrdenado.filter(
                    (paciente) =>
                        Number(
                            paciente.total_adeudado ||
                            0
                        ) > 0
                ).length;


            const conSaldoFavor =
                pacientesResumenOrdenado.filter(
                    (paciente) =>
                        Number(
                            paciente.saldo_a_favor ||
                            0
                        ) > 0
                ).length;


            const alDia =
                pacientesResumenOrdenado.filter(
                    (paciente) =>

                        tieneMovimientoEconomico(
                            paciente
                        ) &&

                        Number(
                            paciente.total_adeudado ||
                            0
                        ) === 0 &&

                        Number(
                            paciente.saldo_a_favor ||
                            0
                        ) === 0

                ).length;


            const sinMovimientos =
                pacientesResumenOrdenado.filter(
                    (paciente) =>
                        !tieneMovimientoEconomico(
                            paciente
                        )
                ).length;


            return {

                todos,

                conDeuda,

                alDia,

                conSaldoFavor,

                sinMovimientos

            };

        }, [
            pacientesResumenOrdenado
        ]);


    /*
    ====================================
    PACIENTES FILTRADOS
    ====================================
    */

    const pacientesResumenFiltrado =
        useMemo(() => {

            switch (filtroPacientes) {

                case 'CON_DEUDA':

                    return pacientesResumenOrdenado.filter(
                        (paciente) =>
                            Number(
                                paciente.total_adeudado ||
                                0
                            ) > 0
                    );


                case 'AL_DIA':

                    return pacientesResumenOrdenado.filter(
                        (paciente) =>

                            tieneMovimientoEconomico(
                                paciente
                            ) &&

                            Number(
                                paciente.total_adeudado ||
                                0
                            ) === 0 &&

                            Number(
                                paciente.saldo_a_favor ||
                                0
                            ) === 0
                    );


                case 'SALDO_FAVOR':

                    return pacientesResumenOrdenado.filter(
                        (paciente) =>
                            Number(
                                paciente.saldo_a_favor ||
                                0
                            ) > 0
                    );


                case 'SIN_MOVIMIENTOS':

                    return pacientesResumenOrdenado.filter(
                        (paciente) =>
                            !tieneMovimientoEconomico(
                                paciente
                            )
                    );


                case 'TODOS':
                default:

                    return pacientesResumenOrdenado;

            }

        }, [
            pacientesResumenOrdenado,
            filtroPacientes
        ]);


    /*
    ====================================
    BUSCAR POR NOMBRE
    ====================================
    */

    const pacientesResumenVisible =
        useMemo(() => {

            const busqueda =
                busquedaPaciente
                    .trim()
                    .toLocaleLowerCase(
                        'es'
                    );


            if (!busqueda) {

                return pacientesResumenFiltrado;

            }


            return pacientesResumenFiltrado.filter(
                (paciente) => {

                    const nombreCompleto =
                        `${paciente.apellido || ''} ${paciente.nombre || ''}`
                            .trim()
                            .toLocaleLowerCase(
                                'es'
                            );


                    return nombreCompleto.includes(
                        busqueda
                    );

                }
            );

        }, [
            pacientesResumenFiltrado,
            busquedaPaciente
        ]);


    /*
    ====================================
    INDICADOR DE ORDEN
    ====================================
    */

    const getIndicadorOrden = (
        campo
    ) => {

        if (
            ordenPacientes.campo !==
            campo
        ) {
            return '';
        }


        return ordenPacientes.direccion ===
            'asc'
                ? ' ↑'
                : ' ↓';

    };


    /*
    ====================================
    MENSAJE SIN RESULTADOS DEL FILTRO
    ====================================
    */

    const mensajeSinPacientes =
        useMemo(() => {

            switch (filtroPacientes) {

                case 'CON_DEUDA':
                    return 'No hay pacientes con deuda en el período seleccionado.';

                case 'AL_DIA':
                    return 'No hay pacientes al día para mostrar.';

                case 'SALDO_FAVOR':
                    return 'No hay pacientes con saldo a favor.';

                case 'SIN_MOVIMIENTOS':
                    return 'Todos los pacientes tuvieron movimientos económicos en el período seleccionado.';

                case 'TODOS':
                default:
                    return 'No hay pacientes para mostrar.';

            }

        }, [
            filtroPacientes
        ]);


    /*
    ====================================
    TOKEN
    ====================================
    */

    const authToken =
        config?.headers?.Authorization ||
        config?.headers?.authorization ||
        null;


    /*
    ====================================
    PERÍODO A CONSULTAR
    ====================================
    */

    const periodoConsulta =
        useMemo(() => {

            switch (tipoPeriodo) {

                case 'MES_ANTERIOR':
                    return getPreviousMonthPeriod();

                case 'ANIO_ACTUAL':
                    return getCurrentYearPeriod();

                case 'PERSONALIZADO':
                    return {

                        fecha_desde:
                            fechaDesdePersonalizada,

                        fecha_hasta:
                            fechaHastaPersonalizada

                    };

                case 'MES_ACTUAL':
                default:
                    return getCurrentMonthPeriod();

            }

        }, [
            tipoPeriodo,
            fechaDesdePersonalizada,
            fechaHastaPersonalizada
        ]);


    /*
    ====================================
    SINCRONIZAR PACIENTE INICIAL
    ====================================
    */

    useEffect(() => {

        if (
            !idPacienteSeleccionado &&
            idPacienteRedux
        ) {

            setIdPacienteSeleccionado(
                idPacienteRedux
            );

        }

    }, [
        idPacienteRedux,
        idPacienteSeleccionado
    ]);


    /*
    ====================================
    PACIENTE SELECCIONADO
    ====================================
    */

    const pacienteSeleccionado =
        useMemo(() => {

            if (
                !idPacienteSeleccionado ||
                !Array.isArray(pacientes)
            ) {
                return null;
            }


            return (
                pacientes.find(
                    (paciente) =>
                        String(
                            paciente.id_paciente
                        ) ===
                        String(
                            idPacienteSeleccionado
                        )
                ) ||
                null
            );

        }, [
            pacientes,
            idPacienteSeleccionado
        ]);

    /*
    ====================================
    PACIENTES DEL SELECTOR
    ====================================

    El selector superior muestra solamente
    pacientes activos.

    Excepción:

    Si ingresamos al detalle de un paciente
    archivado desde la solapa Archivados,
    conservamos ese paciente dentro del
    selector para que pueda mostrarse
    correctamente como seleccionado.

    No mostramos al resto de los archivados
    en el desplegable habitual.
    ====================================
    */

    const pacientesSelectorEstadisticas =
        useMemo(() => {

            const pacientesActivos =
                pacientes.filter(
                    (paciente) =>
                        paciente.archivado !== true
                );


            if (
                !idPacienteSeleccionado ||
                idPacienteSeleccionado ===
                'TODOS'
            ) {

                return pacientesActivos;

            }


            const seleccionado =
                pacientes.find(
                    (paciente) =>
                        String(
                            paciente.id_paciente
                        ) ===
                        String(
                            idPacienteSeleccionado
                        )
                );


            if (
                seleccionado?.archivado === true
            ) {

                const yaIncluido =
                    pacientesActivos.some(
                        (paciente) =>
                            String(
                                paciente.id_paciente
                            ) ===
                            String(
                                seleccionado.id_paciente
                            )
                    );


                if (!yaIncluido) {

                    return [
                        ...pacientesActivos,
                        seleccionado
                    ];

                }

            }


            return pacientesActivos;

        }, [
            pacientes,
            idPacienteSeleccionado
        ]);


    const nombreCompleto =
        esVistaGlobal
            ? 'Todos los pacientes'
            : pacienteSeleccionado
                ? `${pacienteSeleccionado.nombre || ''} ${pacienteSeleccionado.apellido || ''}`.trim()
                : 'Paciente';


    /*
    ====================================
    EVITAR CONSULTAS DUPLICADAS
    ====================================
    */

    const ultimaConsultaRef =
        useRef(null);


    /*
    ====================================
    CARGAR ESTADÍSTICAS
    ====================================
    */

    useEffect(() => {

        if (
            vistaModulo !== 'PACIENTES' ||
            !authToken ||
            !config ||
            !idPacienteSeleccionado
        ) {
            return;
        }


        if (
            tipoPeriodo === 'PERSONALIZADO' &&
            (
                !fechaDesdePersonalizada ||
                !fechaHastaPersonalizada
            )
        ) {
            return;
        }


        if (
            tipoPeriodo === 'PERSONALIZADO' &&
            fechaDesdePersonalizada >
            fechaHastaPersonalizada
        ) {
            return;
        }


        const claveConsulta = [

            idPacienteSeleccionado,

            periodoConsulta.fecha_desde,

            periodoConsulta.fecha_hasta

        ].join('|');


        if (
            ultimaConsultaRef.current ===
            claveConsulta
        ) {
            return;
        }


        ultimaConsultaRef.current =
            claveConsulta;


        const cargarEstadisticas =
            async () => {

                try {

                    if (
                        idPacienteSeleccionado ===
                        'TODOS'
                    ) {

                        await dispatch(
                            cargarEstadisticasProfesionalAction({

                                config,

                                fecha_desde:
                                    periodoConsulta.fecha_desde,

                                fecha_hasta:
                                    periodoConsulta.fecha_hasta

                            })
                        );

                    } else {

                        await dispatch(
                            cargarEstadisticasPacienteAction({

                                config,

                                id_paciente:
                                    idPacienteSeleccionado,

                                fecha_desde:
                                    periodoConsulta.fecha_desde,

                                fecha_hasta:
                                    periodoConsulta.fecha_hasta

                            })
                        );

                    }

                } catch (error) {

                    ultimaConsultaRef.current =
                        null;


                    const mensaje =
                        error.response?.data?.msg ||
                        error.response?.data?.message ||
                        error.userMessage ||
                        'No se pudieron cargar las estadísticas.';


                    await Swal.fire({

                        icon:
                            'error',

                        title:
                            'No se pudieron cargar las estadísticas',

                        text:
                            mensaje,

                        confirmButtonText:
                            'OK',

                        allowOutsideClick:
                            false,

                        allowEscapeKey:
                            false

                    });

                }

            };


        cargarEstadisticas();

    }, [
        authToken,
        config,
        dispatch,
        idPacienteSeleccionado,
        periodoConsulta,
        tipoPeriodo,
        fechaDesdePersonalizada,
        fechaHastaPersonalizada,
        vistaModulo
    ]);


    /*
    ====================================
    CAMBIAR PACIENTE
    ====================================
    */

    const handleCambiarPaciente = (
        nuevoIdPaciente
    ) => {

        setIdPacienteSeleccionado(
            nuevoIdPaciente
        );

    };


    /*
    ====================================
    CARGAR HISTORIAL DE COBROS
    ====================================
    */

    const handleCargarHistorialCobros =
        async () => {

            const cuentaId =
                economia?.cuenta?.id;


            if (!cuentaId) {

                await Swal.fire({

                    icon:
                        'info',

                    title:
                        'Sin historial de cobros',

                    text:
                        'Este paciente todavía no tiene movimientos económicos registrados.',

                    confirmButtonText:
                        'OK'

                });

                return;

            }


            try {

                setCargandoHistorial(
                    true
                );


                const respuesta =
                    await dispatch(
                        cargarHistorialPagosCuentaAction({

                            config,

                            cuenta_id:
                                cuentaId

                        })
                    );


                setHistorialCobros(
                    respuesta
                );


                setHistorialAbierto(
                    true
                );

            } catch (error) {

                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudo cargar el historial de cobros.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo cargar el historial',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });

            } finally {

                setCargandoHistorial(
                    false
                );

            }

        };


    /*
    ====================================
    CORREGIR COBRO
    ====================================
    */

    const handleCorregirCobro =
        async (pago) => {

            if (!pago?.id) {
                return;
            }


            setHistorialAbierto(
                false
            );


            const confirmacion =
                await Swal.fire({

                    icon:
                        'warning',

                    title:
                        '¿Corregir este cobro?',

                    html:
                        `
                        <div style="font-size: 0.9rem;">
                            El cobro de
                            <strong>${formatMoney(pago.importe)}</strong>
                            será anulado completo.
                            <br><br>
                            También se anularán las aplicaciones
                            realizadas sobre las prestaciones.
                            <br><br>
                            Después podrás registrar nuevamente
                            el cobro de forma correcta.
                        </div>
                        `,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        'Sí, corregir cobro',

                    cancelButtonText:
                        'Cancelar',

                    reverseButtons:
                        true

                });


            if (!confirmacion.isConfirmed) {

                setHistorialAbierto(
                    true
                );

                return;

            }


            try {

                setAnulandoPagoId(
                    pago.id
                );


                await dispatch(
                    anularPagoAction({

                        config,

                        pago_id:
                            pago.id

                    })
                );


                await dispatch(
                    cargarEstadisticasPacienteAction({

                        config,

                        id_paciente:
                            idPacienteSeleccionado,

                        fecha_desde:
                            periodoConsulta.fecha_desde,

                        fecha_hasta:
                            periodoConsulta.fecha_hasta

                    })
                );


                const imputacionesPago =
                    Array.isArray(
                        pago.imputaciones
                    )
                        ? pago.imputaciones
                        : [];


                const cargosIdsOriginales =
                    [
                        ...new Set(

                            imputacionesPago
                                .map(
                                    (imputacion) =>
                                        imputacion?.cargo_id ??
                                        imputacion?.cargo?.id
                                )
                                .filter(
                                    (id) =>
                                        id !== null &&
                                        id !== undefined
                                )
                                .map(
                                    (id) =>
                                        Number(id)
                                )
                                .filter(
                                    (id) =>
                                        Number.isFinite(id)
                                )

                        )
                    ];


                const economiaActualizada =
                    await dispatch(
                        cargarResumenEconomicoCompletoAction({

                            config,

                            id_paciente:
                                idPacienteSeleccionado

                        })
                    );


                setCargosParaCobro(
                    Array.isArray(
                        economiaActualizada?.cargos
                    )
                        ? economiaActualizada.cargos
                        : []
                );


                setHistorialCobros(
                    null
                );


                setDatosInicialesCobro({

                    importe:
                        pago.importe,

                    fecha_pago:
                        pago.fecha_pago
                            ? String(
                                pago.fecha_pago
                            ).substring(
                                0,
                                10
                            )
                            : '',

                    medio_pago:
                        pago.medio_pago ||
                        'Transferencia',

                    observacion:
                        pago.observacion ||
                        '',

                    cargos_ids:
                        cargosIdsOriginales

                });


                await Swal.fire({

                    icon:
                        'success',

                    title:
                        'Cobro listo para corregir',

                    text:
                        'El cobro anterior fue anulado. Ahora podés modificar los datos y registrarlo nuevamente.',

                    confirmButtonText:
                        'Continuar'

                });


                setRegistrarCobroAbierto(
                    true
                );

            } catch (error) {

                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudo corregir el cobro.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo corregir el cobro',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });


                setHistorialAbierto(
                    true
                );

            } finally {

                setAnulandoPagoId(
                    null
                );

            }

        };


    /*
    ====================================
    CAMBIAR COBRABLE
    ====================================
    */

    const handleCambiarCobrable =
        async ({
            cargo_id,
            cobrable
        }) => {

            if (!cargo_id) {
                return false;
            }


            try {

                setCambiandoCobrable(
                    true
                );


                await dispatch(
                    cambiarCobrableCargoAction({

                        config,

                        cargo_id,

                        cobrable

                    })
                );


                await dispatch(
                    cargarEstadisticasPacienteAction({

                        config,

                        id_paciente:
                            idPacienteSeleccionado,

                        fecha_desde:
                            periodoConsulta.fecha_desde,

                        fecha_hasta:
                            periodoConsulta.fecha_hasta

                    })
                );


                setTurnoSeleccionado(
                    null
                );


                await Swal.fire({

                    icon:
                        'success',

                    title:
                        cobrable
                            ? 'Cargo activado'
                            : 'Cargo marcado como no cobrar',

                    text:
                        cobrable
                            ? 'El cargo vuelve a generar deuda.'
                            : 'El cargo conserva su importe histórico, pero ya no genera deuda.',

                    confirmButtonText:
                        'OK'

                });


                return true;

            } catch (error) {

                const codigo =
                    error.response?.data?.error_code;


                if (
                    codigo ===
                    'CARGO_CON_COBROS'
                ) {

                    setTurnoSeleccionado(
                        null
                    );


                    await Swal.fire({

                        icon:
                            'warning',

                        title:
                            'Este cargo ya tiene cobros',

                        text:
                            'No se puede cambiar a “No cobrar” porque ya tiene pagos asociados. Si necesitás corregirlo, primero hay que corregir el cobro correspondiente.',

                        confirmButtonText:
                            'OK'

                    });


                    return false;

                }


                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudo modificar el cargo.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo modificar',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });


                return false;

            } finally {

                setCambiandoCobrable(
                    false
                );

            }

        };


    /*
    ====================================
    ABRIR REGISTRAR COBRO
    ====================================
    */

    const handleAbrirRegistrarCobro =
        async () => {

            if (
                !idPacienteSeleccionado ||
                esVistaGlobal
            ) {
                return;
            }


            setDatosInicialesCobro(
                null
            );


            try {

                setCargandoCargosParaCobro(
                    true
                );


                const respuesta =
                    await dispatch(
                        cargarResumenEconomicoCompletoAction({

                            config,

                            id_paciente:
                                idPacienteSeleccionado

                        })
                    );


                setCargosParaCobro(
                    Array.isArray(
                        respuesta?.cargos
                    )
                        ? respuesta.cargos
                        : []
                );


                setRegistrarCobroAbierto(
                    true
                );

            } catch (error) {

                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudieron cargar los cargos pendientes del paciente.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo abrir Registrar cobro',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });

            } finally {

                setCargandoCargosParaCobro(
                    false
                );

            }

        };


    /*
    ====================================
    REGISTRAR COBRO
    ====================================
    */

    const handleRegistrarCobro =
        async ({
            fecha_pago,
            importe,
            medio_pago,
            observacion,
            cargos_ids
        }) => {

            if (
                !Array.isArray(cargos_ids) ||
                cargos_ids.length === 0
            ) {

                await Swal.fire({

                    icon:
                        'warning',

                    title:
                        'Seleccioná al menos una prestación',

                    text:
                        'Tenés que seleccionar qué prestaciones querés incluir en el cobro.',

                    confirmButtonText:
                        'OK'

                });

                return false;

            }


            if (
                !importe ||
                Number(importe) <= 0
            ) {

                await Swal.fire({

                    icon:
                        'warning',

                    title:
                        'Importe inválido',

                    text:
                        'Ingresá el importe recibido.',

                    confirmButtonText:
                        'OK'

                });

                return false;

            }


            if (!fecha_pago) {

                await Swal.fire({

                    icon:
                        'warning',

                    title:
                        'Falta la fecha',

                    text:
                        'Ingresá la fecha en la que se recibió el cobro.',

                    confirmButtonText:
                        'OK'

                });

                return false;

            }


            try {

                setRegistrandoCobro(
                    true
                );


                await dispatch(
                    registrarPagoAction({

                        config,

                        fecha_pago,

                        importe:
                            Number(importe),

                        medio_pago,

                        observacion:
                            observacion?.trim() ||
                            null,

                        cargos_ids

                    })
                );


                await dispatch(
                    cargarEstadisticasPacienteAction({

                        config,

                        id_paciente:
                            idPacienteSeleccionado,

                        fecha_desde:
                            periodoConsulta.fecha_desde,

                        fecha_hasta:
                            periodoConsulta.fecha_hasta

                    })
                );


                setHistorialCobros(
                    null
                );


                setRegistrarCobroAbierto(
                    false
                );


                setDatosInicialesCobro(
                    null
                );


                await Swal.fire({

                    icon:
                        'success',

                    title:
                        'Cobro registrado',

                    text:
                        'El cobro se registró correctamente.',

                    confirmButtonText:
                        'OK'

                });


                return true;

            } catch (error) {

                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudo registrar el cobro.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo registrar el cobro',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });


                return false;

            } finally {

                setRegistrandoCobro(
                    false
                );

            }

        };


    /*
    ====================================
    AYUDA CONCEPTOS ECONÓMICOS
    ====================================
    */

    const handleAbrirAyudaConceptos =
        async () => {

            await Swal.fire({

                title:
                    '¿Qué significa cada dato?',

                width:
                    650,

                html:
                    `
                    <div
                        style="
                            text-align: left;
                            font-size: 0.85rem;
                            line-height: 1.55;
                            color: #3F4B4B;
                        "
                    >

                        <div style="margin-bottom: 12px;">
                            <strong>Generado</strong><br>
                            Importe correspondiente a las
                            prestaciones del período seleccionado
                            que deben cobrarse.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Cobrado</strong><br>
                            Parte de las prestaciones del período
                            que ya fue pagada, independientemente
                            de cuándo se recibió ese dinero.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Ingresado</strong><br>
                            Dinero efectivamente recibido durante
                            el período seleccionado, según la fecha
                            del cobro. Puede incluir pagos de deudas
                            anteriores.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Pendiente</strong><br>
                            Importe de las prestaciones del período
                            que todavía falta cobrar.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Deuda anterior</strong><br>
                            Deuda pendiente correspondiente a
                            prestaciones anteriores al período
                            seleccionado.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Total adeudado</strong><br>
                            Es la suma del pendiente del período
                            más la deuda anterior.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Saldo a favor</strong><br>
                            Dinero recibido que todavía no fue
                            aplicado a ninguna deuda.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Presentismo</strong><br>
                            Porcentaje de sesiones computables
                            a las que el paciente asistió.
                        </div>


                        <div style="margin-bottom: 12px;">
                            <strong>Al día</strong><br>
                            Paciente con movimientos económicos
                            que actualmente no tiene deuda ni
                            saldo a favor.
                        </div>


                        <div style="margin-bottom: 16px;">
                            <strong>Sin movimientos</strong><br>
                            Paciente sin actividad económica
                            registrada para los criterios del
                            período seleccionado.
                        </div>


                        <div
                            style="
                                padding: 12px;
                                border-radius: 8px;
                                background-color: #F3F8F8;
                                border-left: 3px solid #23AAAF;
                            "
                        >

                            <strong>
                                ¿Por qué Cobrado e Ingresado
                                pueden ser distintos?
                            </strong>

                            <br><br>

                            Por ejemplo, si durante agosto se
                            cobra una deuda correspondiente a
                            julio, ese dinero suma a
                            <strong>Ingresado en agosto</strong>,
                            pero no a
                            <strong>
                                Cobrado de prestaciones de agosto
                            </strong>.

                        </div>

                    </div>
                    `,

                confirmButtonText:
                    'Entendido'

            });

        };


    /*
    ====================================
    CÁLCULOS VISUALES
    ====================================
    */

    const totalGenerado =
        Number(
            resumenEconomico.total_generado ||
            0
        );


    const totalCobrado =
        Number(
            resumenEconomico.total_cobrado ||
            0
        );


    /*
    ====================================
    INGRESADO EN EL PERÍODO
    ====================================
    */

    const totalIngresadoPeriodo =
        Number(
            resumenEconomico
                .total_ingresado_periodo ||
            0
        );


    const saldoPendiente =
        Number(
            resumenEconomico.saldo_pendiente ||
            0
        );


    const deudaAnterior =
        Number(
            resumenEconomico.deuda_anterior ||
            0
        );


    const saldoFavor =
        Number(
            resumenEconomico.saldo_a_favor ||
            0
        );


    const totalAdeudado =
        saldoPendiente +
        deudaAnterior;


    const porcentajeCobrado =
        totalGenerado > 0
            ? Math.min(
                100,
                (
                    totalCobrado /
                    totalGenerado
                ) * 100
            )
            : 0;


    const porcentajePresentismo =
        Number(
            asistencia.porcentaje_presentismo ||
            0
        );

    const porcentajePresentismoPadres =
        Number(
            asistenciaPadresBackend
                .porcentaje_presentismo ||
            0
        );


    /*
    ====================================
    APLICAR SALDO A FAVOR
    ====================================
    */

    const handleAplicarSaldoFavor =
        async () => {

            const cuentaId =
                economia?.cuenta?.id;


            if (
                !cuentaId ||
                saldoFavor <= 0 ||
                totalAdeudado <= 0
            ) {
                return;
            }


            const confirmacion =
                await Swal.fire({

                    icon:
                        'question',

                    title:
                        '¿Aplicar saldo a favor?',

                    html:
                        `
                        <div style="font-size: 0.9rem;">
                            Hay
                            <strong>${formatMoney(saldoFavor)}</strong>
                            de saldo a favor.
                            <br><br>
                            Se aplicará automáticamente
                            sobre las deudas más antiguas
                            del paciente.
                        </div>
                        `,

                    showCancelButton:
                        true,

                    confirmButtonText:
                        'Sí, aplicar',

                    cancelButtonText:
                        'Cancelar',

                    reverseButtons:
                        true

                });


            if (!confirmacion.isConfirmed) {
                return;
            }


            try {

                setAplicandoSaldoFavor(
                    true
                );


                const respuesta =
                    await dispatch(
                        aplicarSaldoAFavorAction({

                            config,

                            cuenta_id:
                                cuentaId

                        })
                    );


                await dispatch(
                    cargarEstadisticasPacienteAction({

                        config,

                        id_paciente:
                            idPacienteSeleccionado,

                        fecha_desde:
                            periodoConsulta.fecha_desde,

                        fecha_hasta:
                            periodoConsulta.fecha_hasta

                    })
                );


                setHistorialCobros(
                    null
                );


                setCargosParaCobro(
                    []
                );


                const totalAplicado =
                    Number(
                        respuesta?.resumen
                            ?.total_aplicado ||
                        0
                    );


                const saldoFinal =
                    Number(
                        respuesta?.resumen
                            ?.saldo_a_favor_final ||
                        0
                    );


                await Swal.fire({

                    icon:
                        'success',

                    title:
                        'Saldo aplicado',

                    html:
                        `
                        <div style="font-size: 0.9rem;">
                            Se aplicaron
                            <strong>${formatMoney(totalAplicado)}</strong>
                            a las deudas pendientes.
                            <br><br>
                            Saldo a favor restante:
                            <strong>${formatMoney(saldoFinal)}</strong>.
                        </div>
                        `,

                    confirmButtonText:
                        'OK'

                });

            } catch (error) {

                const mensaje =
                    error.response?.data?.msg ||
                    error.response?.data?.message ||
                    'No se pudo aplicar el saldo a favor.';


                await Swal.fire({

                    icon:
                        'error',

                    title:
                        'No se pudo aplicar el saldo',

                    text:
                        mensaje,

                    confirmButtonText:
                        'OK'

                });

            } finally {

                setAplicandoSaldoFavor(
                    false
                );

            }

        };


    /*
    ====================================
    SIN PACIENTE
    ====================================
    */

    const renderSinPaciente = () => (

        <EstadisticasMain>

            <SinInformacion>

                Seleccioná un paciente desde
                el encabezado para ver sus
                estadísticas y cobros.

            </SinInformacion>

        </EstadisticasMain>

    );


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Cuerpo>

            {/*
            ====================================
            HEADER FIJO
            ====================================

            HeaderUno + HeaderDos permanecen
            visibles mientras se hace scroll.

            Se aplica únicamente a
            Estadísticas y cobros para no
            modificar otras pantallas.
            ====================================
            */}

            <div
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: '#FFFFFF'
                }}
            >

                <HeaderUno />

                <HeaderDos
                    link="/escritorio/pacientes"
                    componente="Estadísticas y cobros"

                    paciente={
                        vistaModulo ===
                        'CENTROS'
                            ? false
                            : undefined
                    }

                    selectorPaciente={
                        vistaModulo ===
                        'PACIENTES'
                    }

                    pacientes={
                        pacientesSelectorEstadisticas
                    }

                    idPacienteSeleccionado={
                        idPacienteSeleccionado
                    }

                    onCambiarPaciente={
                        handleCambiarPaciente
                    }

                    permitirTodosPacientes={
                        vistaModulo ===
                        'PACIENTES'
                    }
                />

            </div>


            <SelectorModuloContenedor>

                <SelectorModuloBoton

                    type="button"

                    $activo={
                        vistaModulo ===
                        'PACIENTES'
                    }

                    onClick={() =>
                        handleCambiarVistaModulo(
                            'PACIENTES'
                        )
                    }
                >
                    Pacientes
                </SelectorModuloBoton>


                <SelectorModuloBoton

                    type="button"

                    $activo={
                        vistaModulo ===
                        'CENTROS'
                    }

                    onClick={() =>
                        handleCambiarVistaModulo(
                            'CENTROS'
                        )
                    }
                >
                    Centros y liquidaciones
                </SelectorModuloBoton>

            </SelectorModuloContenedor>
            

            {/*
            ====================================
            CENTROS Y LIQUIDACIONES
            ====================================

            Se monta una sola vez.

            Después solamente se oculta para
            conservar:

            - centros cargados;
            - período elegido;
            - centro seleccionado;
            - referencias de las consultas.

            De esta manera cambiar de solapa
            no vuelve a consultar al backend.
            ====================================
            */}

            {
                centrosInicializados
                    ? (

                        <div
                            style={{
                                display:
                                    vistaModulo ===
                                        'CENTROS'
                                        ? 'block'
                                        : 'none'
                            }}
                        >

                            <CentrosLiquidaciones

                                refrescoVersion={
                                    refrescoCentrosVersion
                                }
                            />

                        </div>

                    )
                    : null
            }


            {/*
            ====================================
            PACIENTES
            ====================================
            */}

            {
                vistaModulo ===
                    'PACIENTES'

                    ? (

                        !idPacienteSeleccionado

                            ? renderSinPaciente()

                            : (

                                <EstadisticasMain>


                                    {/*
                                    ====================================
                                    CABECERA
                                    ====================================
                                    */}

                                    <EstadisticasCabecera>

                                        <EstadisticasTituloContenedor>

                                            <EstadisticasTitulo>
                                                {nombreCompleto}
                                            </EstadisticasTitulo>


                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '7px'
                                                }}
                                            >

                                                <EstadisticasSubtitulo>

                                                    {
                                                        esVistaGlobal
                                                            ? 'Resumen general de asistencia y situación económica'
                                                            : 'Resumen de asistencia y situación económica'
                                                    }

                                                </EstadisticasSubtitulo>


                                                <BotonAyudaConceptos
                                                    type="button"

                                                    onClick={
                                                        handleAbrirAyudaConceptos
                                                    }

                                                    aria-label="Ver explicación de los conceptos"

                                                    title="¿Qué significa cada dato?"
                                                >
                                                    ?
                                                </BotonAyudaConceptos>

                                            </div>

                                        </EstadisticasTituloContenedor>


                                        {
                                            !esVistaGlobal
                                                ? (

                                                    <AccionesCabecera>

                                                        <BotonSecundario
                                                            type="button"

                                                            onClick={
                                                                handleCargarHistorialCobros
                                                            }

                                                            disabled={
                                                                cargandoHistorial
                                                            }
                                                        >

                                                            {
                                                                cargandoHistorial
                                                                    ? 'Cargando...'
                                                                    : 'Historial de cobros'
                                                            }

                                                        </BotonSecundario>


                                                        <BotonPrincipal
                                                            type="button"

                                                            onClick={
                                                                handleAbrirRegistrarCobro
                                                            }

                                                            disabled={
                                                                cargandoCargosParaCobro
                                                            }
                                                        >

                                                            {
                                                                cargandoCargosParaCobro
                                                                    ? 'Cargando...'
                                                                    : 'Registrar cobro'
                                                            }

                                                        </BotonPrincipal>

                                                    </AccionesCabecera>

                                                )
                                                : null
                                        }

                                    </EstadisticasCabecera>


                                    {/*
                                    ====================================
                                    FILTROS DE PERÍODO
                                    ====================================
                                    */}

                                    <ContenedorFiltros>

                                        <GrupoPeriodos>

                                            <BotonPeriodo
                                                $activo={
                                                    tipoPeriodo ===
                                                    'MES_ACTUAL'
                                                }

                                                onClick={() =>
                                                    setTipoPeriodo(
                                                        'MES_ACTUAL'
                                                    )
                                                }
                                            >
                                                Este mes
                                            </BotonPeriodo>


                                            <BotonPeriodo
                                                $activo={
                                                    tipoPeriodo ===
                                                    'MES_ANTERIOR'
                                                }

                                                onClick={() =>
                                                    setTipoPeriodo(
                                                        'MES_ANTERIOR'
                                                    )
                                                }
                                            >
                                                Mes anterior
                                            </BotonPeriodo>


                                            <BotonPeriodo
                                                $activo={
                                                    tipoPeriodo ===
                                                    'ANIO_ACTUAL'
                                                }

                                                onClick={() =>
                                                    setTipoPeriodo(
                                                        'ANIO_ACTUAL'
                                                    )
                                                }
                                            >
                                                Este año
                                            </BotonPeriodo>


                                            <BotonPeriodo
                                                $activo={
                                                    tipoPeriodo ===
                                                    'PERSONALIZADO'
                                                }

                                                onClick={() =>
                                                    setTipoPeriodo(
                                                        'PERSONALIZADO'
                                                    )
                                                }
                                            >
                                                Personalizado
                                            </BotonPeriodo>

                                        </GrupoPeriodos>


                                        {
                                            tipoPeriodo ===
                                            'PERSONALIZADO'
                                                ? (

                                                    <FechasPersonalizadas>

                                                        <FechaPersonalizadaGrupo>

                                                            <FechaPersonalizadaLabel>
                                                                Desde
                                                            </FechaPersonalizadaLabel>

                                                            <FechaPersonalizadaInput
                                                                type="date"

                                                                value={
                                                                    fechaDesdePersonalizada
                                                                }

                                                                max={
                                                                    fechaHastaPersonalizada ||
                                                                    undefined
                                                                }

                                                                onChange={(e) =>
                                                                    setFechaDesdePersonalizada(
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />

                                                        </FechaPersonalizadaGrupo>


                                                        <FechaPersonalizadaGrupo>

                                                            <FechaPersonalizadaLabel>
                                                                Hasta
                                                            </FechaPersonalizadaLabel>

                                                            <FechaPersonalizadaInput
                                                                type="date"

                                                                value={
                                                                    fechaHastaPersonalizada
                                                                }

                                                                min={
                                                                    fechaDesdePersonalizada ||
                                                                    undefined
                                                                }

                                                                onChange={(e) =>
                                                                    setFechaHastaPersonalizada(
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />

                                                        </FechaPersonalizadaGrupo>

                                                    </FechasPersonalizadas>

                                                )
                                                : null
                                        }


                                        <PeriodoTexto>

                                            {
                                                tipoPeriodo ===
                                                    'PERSONALIZADO' &&
                                                (
                                                    !fechaDesdePersonalizada ||
                                                    !fechaHastaPersonalizada
                                                )

                                                    ? 'Seleccioná el período'

                                                    : (
                                                        <>
                                                            {
                                                                formatDateDisplay(
                                                                    periodoConsulta.fecha_desde
                                                                )
                                                            }

                                                            {' — '}

                                                            {
                                                                formatDateDisplay(
                                                                    periodoConsulta.fecha_hasta
                                                                )
                                                            }
                                                        </>
                                                    )
                                            }

                                        </PeriodoTexto>

                                    </ContenedorFiltros>


                                    {
                                        cargando
                                            ? (

                                                <CargandoEstadisticas>
                                                    Cargando estadísticas...
                                                </CargandoEstadisticas>

                                            )
                                            : (

                                                <>


                                                    {/*
                                                    ====================================
                                                    KPIS
                                                    ====================================
                                                    */}

                                                    <GridKpis>

                                                        <TarjetaKpi
                                                            $color="#23AAAF"
                                                        >

                                                            <KpiTitulo>
                                                                Sesiones paciente
                                                            </KpiTitulo>

                                                            <KpiValor>

                                                                {
                                                                    asistencia
                                                                        .total_computable ||
                                                                    0
                                                                }

                                                            </KpiValor>

                                                            <KpiDetalle>

                                                                {
                                                                    asistencia.presentes ||
                                                                    0
                                                                } realizadas

                                                                {' · '}

                                                                {
                                                                    asistencia.ausentes ||
                                                                    0
                                                                } ausencias

                                                            </KpiDetalle>

                                                        </TarjetaKpi>


                                                        <TarjetaKpi
                                                            $color="#23AAAF"
                                                        >

                                                            <KpiTitulo>
                                                                Presentismo paciente
                                                            </KpiTitulo>

                                                            <KpiValor>

                                                                {
                                                                    porcentajePresentismo
                                                                }%

                                                            </KpiValor>

                                                            <KpiDetalle>

                                                                {
                                                                    asistencia.presentes ||
                                                                    0
                                                                }

                                                                {' de '}

                                                                {
                                                                    asistencia
                                                                        .total_computable ||
                                                                    0
                                                                }

                                                                {' sesiones'}

                                                            </KpiDetalle>

                                                        </TarjetaKpi>


                                                        <TarjetaKpi
                                                            $color="#D76970"
                                                        >

                                                            <KpiTitulo>
                                                                Ausentismo paciente
                                                            </KpiTitulo>

                                                            <KpiValor>

                                                                {
                                                                    Number(
                                                                        asistencia
                                                                            .porcentaje_ausentismo ||
                                                                        0
                                                                    )
                                                                }%

                                                            </KpiValor>

                                                            <KpiDetalle>

                                                                {
                                                                    asistencia.no_asistio ||
                                                                    0
                                                                } no asistió

                                                                {' · '}

                                                                {
                                                                    asistencia.cancelados ||
                                                                    0
                                                                } canceladas

                                                            </KpiDetalle>

                                                        </TarjetaKpi>


                                                        <TarjetaKpi
                                                            $color="#655EE8"
                                                        >

                                                            <KpiTitulo>
                                                                Total adeudado
                                                            </KpiTitulo>

                                                            <KpiValor>

                                                                {
                                                                    formatMoney(
                                                                        totalAdeudado
                                                                    )
                                                                }

                                                            </KpiValor>

                                                            <KpiDetalle>

                                                                {
                                                                    formatMoney(
                                                                        saldoPendiente
                                                                    )
                                                                } período

                                                                {' + '}

                                                                {
                                                                    formatMoney(
                                                                        deudaAnterior
                                                                    )
                                                                } anterior

                                                            </KpiDetalle>

                                                        </TarjetaKpi>

                                                    </GridKpis>


                                                    {/*
                                                    ====================================
                                                    ECONOMÍA
                                                    ====================================
                                                    */}

                                                    <GridEconomia>

                                                        <TarjetaEconomia>

                                                            <EconomiaTitulo>

                                                                <PuntoColor
                                                                    $color="#655EE8"
                                                                />

                                                                Generado

                                                            </EconomiaTitulo>

                                                            <EconomiaValor>

                                                                {
                                                                    formatMoney(
                                                                        totalGenerado
                                                                    )
                                                                }

                                                            </EconomiaValor>

                                                            <EconomiaDetalle>
                                                                del período
                                                            </EconomiaDetalle>

                                                        </TarjetaEconomia>


                                                        <TarjetaEconomia>

                                                            <EconomiaTitulo>

                                                                <PuntoColor
                                                                    $color="#23AAAF"
                                                                />

                                                                Ingresado

                                                            </EconomiaTitulo>


                                                            <EconomiaValor>

                                                                {
                                                                    formatMoney(
                                                                        totalIngresadoPeriodo
                                                                    )
                                                                }

                                                            </EconomiaValor>


                                                            <EconomiaDetalle>
                                                                recibido en el período
                                                            </EconomiaDetalle>

                                                        </TarjetaEconomia>


                                                        <TarjetaEconomia>

                                                            <EconomiaTitulo>

                                                                <PuntoColor
                                                                    $color="#EFC340"
                                                                />

                                                                Pendiente

                                                            </EconomiaTitulo>

                                                            <EconomiaValor>

                                                                {
                                                                    formatMoney(
                                                                        saldoPendiente
                                                                    )
                                                                }

                                                            </EconomiaValor>

                                                            <EconomiaDetalle>
                                                                del período
                                                            </EconomiaDetalle>

                                                        </TarjetaEconomia>


                                                        <TarjetaEconomia>

                                                            <EconomiaTitulo>

                                                                <PuntoColor
                                                                    $color="#D76970"
                                                                />

                                                                Deuda anterior

                                                            </EconomiaTitulo>

                                                            <EconomiaValor>

                                                                {
                                                                    formatMoney(
                                                                        deudaAnterior
                                                                    )
                                                                }

                                                            </EconomiaValor>

                                                            <EconomiaDetalle>
                                                                previa al período
                                                            </EconomiaDetalle>

                                                        </TarjetaEconomia>


                                                        <TarjetaEconomia>

                                                            <EconomiaTitulo>

                                                                <PuntoColor
                                                                    $color="#FC8906"
                                                                />

                                                                Saldo a favor

                                                            </EconomiaTitulo>

                                                            <EconomiaValor>

                                                                {
                                                                    formatMoney(
                                                                        saldoFavor
                                                                    )
                                                                }

                                                            </EconomiaValor>

                                                            <EconomiaDetalle>

                                                                {
                                                                    esVistaGlobal
                                                                        ? 'total entre pacientes'
                                                                        : 'cuenta actual'
                                                                }

                                                            </EconomiaDetalle>


                                                            {
                                                                saldoFavor > 0 &&
                                                                totalAdeudado > 0 &&
                                                                economia?.cuenta?.id
                                                                    ? (

                                                                        <BotonAccionEconomia
                                                                            type="button"

                                                                            onClick={
                                                                                handleAplicarSaldoFavor
                                                                            }

                                                                            disabled={
                                                                                aplicandoSaldoFavor
                                                                            }
                                                                        >

                                                                            {
                                                                                aplicandoSaldoFavor
                                                                                    ? 'Aplicando...'
                                                                                    : 'Aplicar a deuda'
                                                                            }

                                                                        </BotonAccionEconomia>

                                                                    )
                                                                    : null
                                                            }

                                                        </TarjetaEconomia>

                                                    </GridEconomia>


                                                    {/*
                                                    ====================================
                                                    DEUDA ANTERIOR
                                                    ====================================
                                                    */}

                                                    {
                                                        deudaAnterior > 0
                                                            ? (

                                                                <AvisoDeuda>

                                                                    <AvisoDeudaIcono>
                                                                        !
                                                                    </AvisoDeudaIcono>

                                                                    <AvisoDeudaContenido>

                                                                        <AvisoDeudaTitulo>

                                                                            Hay {
                                                                                formatMoney(
                                                                                    deudaAnterior
                                                                                )
                                                                            } de deuda anterior

                                                                        </AvisoDeudaTitulo>

                                                                        <AvisoDeudaTexto>

                                                                            Corresponde a cargos
                                                                            anteriores al período
                                                                            seleccionado y se muestra
                                                                            separada para no mezclarla
                                                                            con la actividad actual.

                                                                        </AvisoDeudaTexto>

                                                                    </AvisoDeudaContenido>

                                                                </AvisoDeuda>

                                                            )
                                                            : null
                                                    }


                                                    {/*
                                                    ====================================
                                                    PANELES
                                                    ====================================
                                                    */}

                                                    <GridPaneles>

                                                        <Panel>

                                                            <PanelCabecera>

                                                                <div>

                                                                    <PanelTitulo>
                                                                        Asistencia del paciente
                                                                    </PanelTitulo>

                                                                    <PanelSubtitulo>

                                                                        {
                                                                            esVistaGlobal
                                                                                ? 'sesiones de todos los pacientes'
                                                                                : `${asistencia.total_computable || 0} sesiones computables`
                                                                        }

                                                                    </PanelSubtitulo>

                                                                </div>

                                                            </PanelCabecera>


                                                            <PresentismoContenido>

                                                                <GraficoPresentismo
                                                                    $porcentaje={
                                                                        porcentajePresentismo
                                                                    }
                                                                >

                                                                    <GraficoPresentismoTexto>

                                                                        <GraficoPresentismoValor>

                                                                            {
                                                                                porcentajePresentismo
                                                                            }%

                                                                        </GraficoPresentismoValor>

                                                                        <GraficoPresentismoLabel>
                                                                            Presentismo
                                                                        </GraficoPresentismoLabel>

                                                                    </GraficoPresentismoTexto>

                                                                </GraficoPresentismo>


                                                                <ListaAsistencia>

                                                                    <ItemAsistencia>

                                                                        <PuntoColor
                                                                            $color="#23AAAF"
                                                                        />

                                                                        Realizadas

                                                                        <ItemAsistenciaValor>

                                                                            {
                                                                                asistencia.presentes ||
                                                                                0
                                                                            }

                                                                        </ItemAsistenciaValor>

                                                                    </ItemAsistencia>


                                                                    <ItemAsistencia>

                                                                        <PuntoColor
                                                                            $color="#FC8906"
                                                                        />

                                                                        No asistió

                                                                        <ItemAsistenciaValor>

                                                                            {
                                                                                asistencia.no_asistio ||
                                                                                0
                                                                            }

                                                                        </ItemAsistenciaValor>

                                                                    </ItemAsistencia>


                                                                    <ItemAsistencia>

                                                                        <PuntoColor
                                                                            $color="#D76970"
                                                                        />

                                                                        Canceladas

                                                                        <ItemAsistenciaValor>

                                                                            {
                                                                                asistencia.cancelados ||
                                                                                0
                                                                            }

                                                                        </ItemAsistenciaValor>

                                                                    </ItemAsistencia>

                                                                </ListaAsistencia>

                                                            </PresentismoContenido>


                                                            {
                                                                !esVistaGlobal
                                                                    ? (

                                                                        <>

                                                                            <div
                                                                                style={{
                                                                                    height: '1px',
                                                                                    backgroundColor: '#E8EEEE',
                                                                                    margin: '22px 0'
                                                                                }}
                                                                            />


                                                                            <PanelCabecera>

                                                                                <div>

                                                                                    <PanelTitulo>
                                                                                        Asistencia de padres
                                                                                    </PanelTitulo>

                                                                                    <PanelSubtitulo>

                                                                                        {
                                                                                            asistenciaPadresBackend
                                                                                                .total_computable ||
                                                                                            0
                                                                                        } reuniones computables

                                                                                    </PanelSubtitulo>

                                                                                </div>

                                                                            </PanelCabecera>


                                                                            <PresentismoContenido>

                                                                                <GraficoPresentismo
                                                                                    $porcentaje={
                                                                                        porcentajePresentismoPadres
                                                                                    }
                                                                                >

                                                                                    <GraficoPresentismoTexto>

                                                                                        <GraficoPresentismoValor>

                                                                                            {
                                                                                                porcentajePresentismoPadres
                                                                                            }%

                                                                                        </GraficoPresentismoValor>

                                                                                        <GraficoPresentismoLabel>
                                                                                            Presentismo
                                                                                        </GraficoPresentismoLabel>

                                                                                    </GraficoPresentismoTexto>

                                                                                </GraficoPresentismo>


                                                                                <ListaAsistencia>

                                                                                    <ItemAsistencia>

                                                                                        <PuntoColor
                                                                                            $color="#23AAAF"
                                                                                        />

                                                                                        Realizadas

                                                                                        <ItemAsistenciaValor>

                                                                                            {
                                                                                                asistenciaPadresBackend
                                                                                                    .presentes ||
                                                                                                0
                                                                                            }

                                                                                        </ItemAsistenciaValor>

                                                                                    </ItemAsistencia>


                                                                                    <ItemAsistencia>

                                                                                        <PuntoColor
                                                                                            $color="#FC8906"
                                                                                        />

                                                                                        No asistió

                                                                                        <ItemAsistenciaValor>

                                                                                            {
                                                                                                asistenciaPadresBackend
                                                                                                    .no_asistio ||
                                                                                                0
                                                                                            }

                                                                                        </ItemAsistenciaValor>

                                                                                    </ItemAsistencia>


                                                                                    <ItemAsistencia>

                                                                                        <PuntoColor
                                                                                            $color="#D76970"
                                                                                        />

                                                                                        Canceladas

                                                                                        <ItemAsistenciaValor>

                                                                                            {
                                                                                                asistenciaPadresBackend
                                                                                                    .cancelados ||
                                                                                                0
                                                                                            }

                                                                                        </ItemAsistenciaValor>

                                                                                    </ItemAsistencia>

                                                                                </ListaAsistencia>

                                                                            </PresentismoContenido>

                                                                        </>

                                                                    )
                                                                    : null
                                                            }

                                                        </Panel>


                                                        <Panel>

                                                            <PanelCabecera>

                                                                <div>

                                                                    <PanelTitulo>
                                                                        Cobranza del período
                                                                    </PanelTitulo>

                                                                    <PanelSubtitulo>
                                                                        prestaciones generadas y dinero recibido
                                                                    </PanelSubtitulo>

                                                                </div>

                                                            </PanelCabecera>


                                                            <FilaEconomia>

                                                                <FilaEconomiaNombre>
                                                                    Importe generado
                                                                </FilaEconomiaNombre>

                                                                <FilaEconomiaValor>

                                                                    {
                                                                        formatMoney(
                                                                            totalGenerado
                                                                        )
                                                                    }

                                                                </FilaEconomiaValor>

                                                            </FilaEconomia>


                                                            <FilaEconomia>

                                                                <FilaEconomiaNombre>
                                                                    Cobrado de prestaciones
                                                                </FilaEconomiaNombre>

                                                                <FilaEconomiaValor>

                                                                    {
                                                                        formatMoney(
                                                                            totalCobrado
                                                                        )
                                                                    }

                                                                </FilaEconomiaValor>

                                                            </FilaEconomia>


                                                            <FilaEconomia>

                                                                <FilaEconomiaNombre>
                                                                    Ingresado en el período
                                                                </FilaEconomiaNombre>

                                                                <FilaEconomiaValor
                                                                    $color="#18898D"
                                                                >

                                                                    {
                                                                        formatMoney(
                                                                            totalIngresadoPeriodo
                                                                        )
                                                                    }

                                                                </FilaEconomiaValor>

                                                            </FilaEconomia>


                                                            <FilaEconomia>

                                                                <FilaEconomiaNombre>
                                                                    Pendiente del período
                                                                </FilaEconomiaNombre>

                                                                <FilaEconomiaValor
                                                                    $color="#92720A"
                                                                >

                                                                    {
                                                                        formatMoney(
                                                                            saldoPendiente
                                                                        )
                                                                    }

                                                                </FilaEconomiaValor>

                                                            </FilaEconomia>


                                                            <FilaEconomia>

                                                                <FilaEconomiaNombre>
                                                                    Deuda anterior
                                                                </FilaEconomiaNombre>

                                                                <FilaEconomiaValor
                                                                    $color="#D76970"
                                                                >

                                                                    {
                                                                        formatMoney(
                                                                            deudaAnterior
                                                                        )
                                                                    }

                                                                </FilaEconomiaValor>

                                                            </FilaEconomia>


                                                            <BarraProgreso>

                                                                <BarraProgresoInterna
                                                                    $porcentaje={
                                                                        porcentajeCobrado
                                                                    }
                                                                />

                                                            </BarraProgreso>


                                                            <BarraProgresoDetalle>

                                                                <span>

                                                                    {
                                                                        Math.round(
                                                                            porcentajeCobrado
                                                                        )
                                                                    }% cobrado

                                                                </span>

                                                                <span>

                                                                    {
                                                                        formatMoney(
                                                                            totalCobrado
                                                                        )
                                                                    }

                                                                    {' de '}

                                                                    {
                                                                        formatMoney(
                                                                            totalGenerado
                                                                        )
                                                                    }

                                                                </span>

                                                            </BarraProgresoDetalle>

                                                        </Panel>

                                                    </GridPaneles>


                                                    {/*
                                                    ====================================
                                                    DETALLE INFERIOR
                                                    ====================================
                                                    */}

                                                    {
                                                        esVistaGlobal
                                                            ? (

                                                                <>

                                                                    <SeccionTitulo>

                                                                        <SeccionTituloPrincipal>
                                                                            Resumen por paciente
                                                                        </SeccionTituloPrincipal>

                                                                        <SeccionTituloSecundario>

                                                                            Ordená la tabla para detectar
                                                                            rápidamente deudas, cobros,
                                                                            facturación y asistencia.

                                                                            Hacé clic sobre un paciente
                                                                            para ver su detalle.

                                                                        </SeccionTituloSecundario>

                                                                    </SeccionTitulo>

                                                                    {/*
                                                                    ====================================
                                                                    ACTIVOS / ARCHIVADOS
                                                                    ====================================
                                                                    */}

                                                                    <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px',
                                                                            marginBottom: '14px'
                                                                        }}
                                                                    >

                                                                        <BotonPeriodo
                                                                            type="button"

                                                                            $activo={
                                                                                vistaPacientes ===
                                                                                'activos'
                                                                            }

                                                                            onClick={() =>
                                                                                handleCambiarVistaPacientes(
                                                                                    'activos'
                                                                                )
                                                                            }
                                                                        >

                                                                            Activos ({
                                                                                cantidadesVistaPacientes.activos
                                                                            })

                                                                        </BotonPeriodo>


                                                                        <BotonPeriodo
                                                                            type="button"

                                                                            $activo={
                                                                                vistaPacientes ===
                                                                                'archivados'
                                                                            }

                                                                            onClick={() =>
                                                                                handleCambiarVistaPacientes(
                                                                                    'archivados'
                                                                                )
                                                                            }
                                                                        >

                                                                            Archivados ({
                                                                                cantidadesVistaPacientes.archivados
                                                                            })

                                                                        </BotonPeriodo>

                                                                    </div>

                                                                    <BarraResumenPacientes>

                                                                        <GrupoPeriodos>

                                                                            <BotonPeriodo
                                                                                type="button"

                                                                                $activo={
                                                                                    filtroPacientes ===
                                                                                    'TODOS'
                                                                                }

                                                                                onClick={() =>
                                                                                    setFiltroPacientes(
                                                                                        'TODOS'
                                                                                    )
                                                                                }
                                                                            >

                                                                                Todos ({
                                                                                    cantidadesFiltroPacientes.todos
                                                                                })

                                                                            </BotonPeriodo>


                                                                            <BotonPeriodo
                                                                                type="button"

                                                                                $activo={
                                                                                    filtroPacientes ===
                                                                                    'CON_DEUDA'
                                                                                }

                                                                                onClick={() =>
                                                                                    setFiltroPacientes(
                                                                                        'CON_DEUDA'
                                                                                    )
                                                                                }
                                                                            >

                                                                                Con deuda ({
                                                                                    cantidadesFiltroPacientes.conDeuda
                                                                                })

                                                                            </BotonPeriodo>


                                                                            <BotonPeriodo
                                                                                type="button"

                                                                                $activo={
                                                                                    filtroPacientes ===
                                                                                    'AL_DIA'
                                                                                }

                                                                                onClick={() =>
                                                                                    setFiltroPacientes(
                                                                                        'AL_DIA'
                                                                                    )
                                                                                }
                                                                            >

                                                                                Al día ({
                                                                                    cantidadesFiltroPacientes.alDia
                                                                                })

                                                                            </BotonPeriodo>


                                                                            <BotonPeriodo
                                                                                type="button"

                                                                                $activo={
                                                                                    filtroPacientes ===
                                                                                    'SALDO_FAVOR'
                                                                                }

                                                                                onClick={() =>
                                                                                    setFiltroPacientes(
                                                                                        'SALDO_FAVOR'
                                                                                    )
                                                                                }
                                                                            >

                                                                                Con saldo a favor ({
                                                                                    cantidadesFiltroPacientes.conSaldoFavor
                                                                                })

                                                                            </BotonPeriodo>


                                                                            <BotonPeriodo
                                                                                type="button"

                                                                                $activo={
                                                                                    filtroPacientes ===
                                                                                    'SIN_MOVIMIENTOS'
                                                                                }

                                                                                onClick={() =>
                                                                                    setFiltroPacientes(
                                                                                        'SIN_MOVIMIENTOS'
                                                                                    )
                                                                                }
                                                                            >

                                                                                Sin movimientos ({
                                                                                    cantidadesFiltroPacientes.sinMovimientos
                                                                                })

                                                                            </BotonPeriodo>

                                                                        </GrupoPeriodos>


                                                                        <BuscadorPacientes
                                                                            type="text"

                                                                            value={
                                                                                busquedaPaciente
                                                                            }

                                                                            placeholder="Buscar paciente..."

                                                                            onChange={(e) =>
                                                                                setBusquedaPaciente(
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />

                                                                    </BarraResumenPacientes>


                                                                    <TablaContenedor>

                                                                        {
                                                                            pacientesResumenVisible
                                                                                .length === 0
                                                                                ? (

                                                                                    <SinInformacion>

                                                                                        {
                                                                                            busquedaPaciente.trim()

                                                                                                ? 'No encontramos pacientes con ese nombre.'

                                                                                                : mensajeSinPacientes
                                                                                        }

                                                                                    </SinInformacion>

                                                                                )
                                                                                : (

                                                                                    <TablaTurnos>

                                                                                        <thead>

                                                                                            <tr>

                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'nombre'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Paciente
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'nombre'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'sesiones_computables'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Sesiones
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'sesiones_computables'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'porcentaje_presentismo'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Presentismo
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'porcentaje_presentismo'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'total_generado'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Generado
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'total_generado'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'total_cobrado'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Cobrado
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'total_cobrado'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'total_ingresado_periodo'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Ingresado
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'total_ingresado_periodo'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'saldo_pendiente'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Pendiente
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'saldo_pendiente'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'deuda_anterior'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Deuda anterior
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'deuda_anterior'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'total_adeudado'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Total adeudado
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'total_adeudado'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>


                                                                                                <th>

                                                                                                    <BotonOrdenTabla
                                                                                                        type="button"

                                                                                                        onClick={() =>
                                                                                                            handleOrdenarPacientes(
                                                                                                                'saldo_a_favor'
                                                                                                            )
                                                                                                        }
                                                                                                    >

                                                                                                        Saldo a favor
                                                                                                        {
                                                                                                            getIndicadorOrden(
                                                                                                                'saldo_a_favor'
                                                                                                            )
                                                                                                        }

                                                                                                    </BotonOrdenTabla>

                                                                                                </th>

                                                                                            </tr>

                                                                                        </thead>


                                                                                        <tbody>

                                                                                            {
                                                                                                pacientesResumenVisible.map(
                                                                                                    (paciente) => {

                                                                                                        const nombrePaciente =
                                                                                                            `${paciente.apellido || ''}, ${paciente.nombre || ''}`
                                                                                                                .replace(
                                                                                                                    /^,\s*/,
                                                                                                                    ''
                                                                                                                )
                                                                                                                .trim();


                                                                                                        return (

                                                                                                            <tr
                                                                                                                key={
                                                                                                                    paciente.id_paciente
                                                                                                                }

                                                                                                                onClick={() =>
                                                                                                                    handleCambiarPaciente(
                                                                                                                        paciente.id_paciente
                                                                                                                    )
                                                                                                                }

                                                                                                                onKeyDown={(e) => {

                                                                                                                    if (
                                                                                                                        e.key ===
                                                                                                                            'Enter' ||
                                                                                                                        e.key ===
                                                                                                                            ' '
                                                                                                                    ) {

                                                                                                                        e.preventDefault();

                                                                                                                        handleCambiarPaciente(
                                                                                                                            paciente.id_paciente
                                                                                                                        );

                                                                                                                    }

                                                                                                                }}

                                                                                                                role="button"
                                                                                                                tabIndex={0}
                                                                                                            >

                                                                                                                <td>

                                                                                                                    <strong>

                                                                                                                        {
                                                                                                                            nombrePaciente ||
                                                                                                                            'Paciente'
                                                                                                                        }

                                                                                                                    </strong>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    {
                                                                                                                        paciente
                                                                                                                            .sesiones_computables
                                                                                                                    }

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <strong>

                                                                                                                        {
                                                                                                                            paciente
                                                                                                                                .porcentaje_presentismo
                                                                                                                        }%

                                                                                                                    </strong>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .total_generado
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .total_cobrado
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .total_ingresado_periodo
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .saldo_pendiente
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .deuda_anterior
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        <strong>

                                                                                                                            {
                                                                                                                                formatMoney(
                                                                                                                                    paciente
                                                                                                                                        .total_adeudado
                                                                                                                                )
                                                                                                                            }

                                                                                                                        </strong>

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            formatMoney(
                                                                                                                                paciente
                                                                                                                                    .saldo_a_favor
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>

                                                                                                            </tr>

                                                                                                        );

                                                                                                    }
                                                                                                )
                                                                                            }

                                                                                        </tbody>

                                                                                    </TablaTurnos>

                                                                                )
                                                                        }

                                                                    </TablaContenedor>

                                                                </>

                                                            )
                                                            : (

                                                                <>

                                                                    <SeccionTitulo>

                                                                        <SeccionTituloPrincipal>
                                                                            Prestaciones y cobros
                                                                        </SeccionTituloPrincipal>

                                                                        <SeccionTituloSecundario>

                                                                            Cada fila combina el turno
                                                                            del calendario con su
                                                                            situación económica.

                                                                        </SeccionTituloSecundario>

                                                                    </SeccionTitulo>


                                                                    <TablaContenedor>

                                                                        {
                                                                            turnos.length === 0
                                                                                ? (

                                                                                    <SinInformacion>

                                                                                        No hay prestaciones para
                                                                                        el período seleccionado.

                                                                                    </SinInformacion>

                                                                                )
                                                                                : (

                                                                                    <TablaTurnos>

                                                                                        <thead>

                                                                                            <tr>

                                                                                                <th>
                                                                                                    Fecha
                                                                                                </th>

                                                                                                <th>
                                                                                                    Tipo
                                                                                                </th>

                                                                                                <th>
                                                                                                    Estado
                                                                                                </th>

                                                                                                <th>
                                                                                                    Honorarios
                                                                                                </th>

                                                                                                <th>
                                                                                                    ¿Cobrar?
                                                                                                </th>

                                                                                                <th>
                                                                                                    Estado pago
                                                                                                </th>

                                                                                                <th>
                                                                                                    Pagado
                                                                                                </th>

                                                                                                <th>
                                                                                                    Saldo
                                                                                                </th>

                                                                                            </tr>

                                                                                        </thead>


                                                                                        <tbody>

                                                                                            {
                                                                                                turnos.map(
                                                                                                    (turno) => {

                                                                                                        const tieneCargo =
                                                                                                            Boolean(
                                                                                                                turno.tiene_cargo
                                                                                                            );


                                                                                                        const cobrable =
                                                                                                            Boolean(
                                                                                                                turno.cobrable
                                                                                                            );


                                                                                                        const estadoPago =
                                                                                                            turno.estado_pago ||
                                                                                                            'SIN_CARGO';


                                                                                                        return (

                                                                                                            <tr
                                                                                                                key={
                                                                                                                    turno.turno_id
                                                                                                                }

                                                                                                                onClick={() =>
                                                                                                                    handleAbrirDetalle(
                                                                                                                        turno
                                                                                                                    )
                                                                                                                }

                                                                                                                onKeyDown={(e) => {

                                                                                                                    if (
                                                                                                                        e.key ===
                                                                                                                            'Enter' ||
                                                                                                                        e.key ===
                                                                                                                            ' '
                                                                                                                    ) {

                                                                                                                        e.preventDefault();

                                                                                                                        handleAbrirDetalle(
                                                                                                                            turno
                                                                                                                        );

                                                                                                                    }

                                                                                                                }}

                                                                                                                role="button"
                                                                                                                tabIndex={0}
                                                                                                            >

                                                                                                                <td>

                                                                                                                    <strong>

                                                                                                                        {
                                                                                                                            formatDateDisplay(
                                                                                                                                turno.fecha_turno
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </strong>

                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            marginTop:
                                                                                                                                '3px',

                                                                                                                            fontSize:
                                                                                                                                '0.65rem',

                                                                                                                            color:
                                                                                                                                '#737F7F'
                                                                                                                        }}
                                                                                                                    >

                                                                                                                        {
                                                                                                                            turno.hora_inicio ||
                                                                                                                            ''
                                                                                                                        }

                                                                                                                        {
                                                                                                                            turno.hora_fin
                                                                                                                                ? ` - ${turno.hora_fin}`
                                                                                                                                : ''
                                                                                                                        }

                                                                                                                    </div>

                                                                                                                </td>

                                                                                                                <td>

                                                                                                                    {
                                                                                                                        getTipoTurnoLabel(
                                                                                                                            turno.tipo_turno
                                                                                                                        )
                                                                                                                    }

                                                                                                                </td>

                                                                                                                <td>

                                                                                                                    <EstadoBadge
                                                                                                                        $tipo={
                                                                                                                            turno.estado_turno
                                                                                                                        }
                                                                                                                    >

                                                                                                                        {
                                                                                                                            getEstadoTurnoLabel(
                                                                                                                                turno.estado_turno
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </EstadoBadge>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            turno.honorarios !==
                                                                                                                                null &&
                                                                                                                            turno.honorarios !==
                                                                                                                                undefined &&
                                                                                                                            turno.honorarios !==
                                                                                                                                ''
                                                                                                                                ? formatMoney(
                                                                                                                                    turno.honorarios
                                                                                                                                )
                                                                                                                                : '—'
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    {
                                                                                                                        !tieneCargo
                                                                                                                            ? '—'
                                                                                                                            : cobrable
                                                                                                                                ? 'Sí'
                                                                                                                                : 'No'
                                                                                                                    }

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <EstadoBadge
                                                                                                                        $tipo={
                                                                                                                            estadoPago
                                                                                                                        }
                                                                                                                    >

                                                                                                                        {
                                                                                                                            getEstadoPagoLabel(
                                                                                                                                estadoPago
                                                                                                                            )
                                                                                                                        }

                                                                                                                    </EstadoBadge>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            tieneCargo
                                                                                                                                ? formatMoney(
                                                                                                                                    turno.total_imputado
                                                                                                                                )
                                                                                                                                : '—'
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>


                                                                                                                <td>

                                                                                                                    <Importe>

                                                                                                                        {
                                                                                                                            !tieneCargo ||
                                                                                                                            !cobrable
                                                                                                                                ? '—'
                                                                                                                                : formatMoney(
                                                                                                                                    turno.saldo_pendiente
                                                                                                                                )
                                                                                                                        }

                                                                                                                    </Importe>

                                                                                                                </td>

                                                                                                            </tr>

                                                                                                        );

                                                                                                    }
                                                                                                )
                                                                                            }

                                                                                        </tbody>

                                                                                    </TablaTurnos>

                                                                                )
                                                                        }

                                                                    </TablaContenedor>

                                                                </>

                                                            )
                                                    }

                                                </>

                                            )
                                    }

                                </EstadisticasMain>

                                    )

                            )
                        : null
                    }


                    <CobroDetalleModal
                        isOpen={
                            Boolean(
                                turnoSeleccionado
                            )
                        }

                        onClose={
                            handleCerrarDetalle
                        }

                        turno={
                            turnoSeleccionado
                        }

                        onCambiarCobrable={
                            handleCambiarCobrable
                        }

                        cambiandoCobrable={
                            cambiandoCobrable
                        }
                    />


                    <HistorialCobrosModal
                        isOpen={
                            historialAbierto
                        }

                        onClose={() =>
                            setHistorialAbierto(
                                false
                            )
                        }

                        historial={
                            historialCobros
                        }

                        onCorregirCobro={
                            handleCorregirCobro
                        }

                        anulandoPagoId={
                            anulandoPagoId
                        }
                    />


                                        <RegistrarCobroModal
                        isOpen={
                            registrarCobroAbierto
                        }

                        onClose={() => {

                            setRegistrarCobroAbierto(
                                false
                            );

                            setDatosInicialesCobro(
                                null
                            );

                        }}

                        cargos={
                            cargosParaCobro
                        }

                        onRegistrar={
                            handleRegistrarCobro
                        }

                        guardando={
                            registrandoCobro
                        }

                        datosIniciales={
                            datosInicialesCobro
                        }
                    />

                </Cuerpo>

            );

}


export default EstadisticasCobros;